import { DEFAULT_STATE } from "byzantine";

type Props = {
  user?: API.User;
  accounts?: API.AnyAccount[];
  limits?: API.Limits.ByType;
  bankingMenus?: Record<string, unknown>;
  institutionApps?: unknown[];
};

const preloadState = ({
  user,
  accounts = [],
  limits = {},
  bankingMenus,
  institutionApps,
}: Props) => {
  const defaultState = structuredClone(DEFAULT_STATE);
  defaultState.user.user = user || null;
  defaultState.accounts.byId = Object.fromEntries(
    accounts.map((a) => [a.id, a])
  );
  defaultState.limits.data = limits;
  if (bankingMenus || institutionApps) {
    const institutionData = defaultState.institution.data as Record<
      string,
      unknown
    >;
    if (bankingMenus) {
      institutionData.banking_menus = bankingMenus;
    }
    if (institutionApps) {
      institutionData.apps = institutionApps;
    }
  }
  return defaultState;
};

export default preloadState;
